import axios from "./axiosInstance";
import { Globals } from "../global/Globals";
import {fetchByfilter} from './GenericAPI'

export const fetch_Brief_Proposals =async (proposalId,pageNumber) =>{
  
 
    const config = {
      headers: {
        'Content-Type': 'application/json' // Set the Content-Type header
      }
    };
  
    const endpoint = Globals.ENDPOINT.HALFPAGE_BRIEF + proposalId;
    const apiResponse= await axios.get(endpoint,config);
    console.log("apiresponse",apiResponse);
    return apiResponse;
  }

  export const fetchProposalDetails =async (producerId,proposalId, proposalDetailId) =>{
    const config = {
      headers: {
        'Content-Type': 'application/json' // Set the Content-Type header
      }
    };
    const endpoint = Globals.ENDPOINT.SOLICITED_EDIT_PROPOSAL+producerId+`&proposalId=${proposalId}`+`&proposalDetailId=${proposalDetailId}`;
    const apiResponse= await axios.get(endpoint,config);
    console.log("apiresponse",apiResponse);
    return apiResponse;
  }
  
  export const getAllCurrencyName = async() => {

    const apiResponse= await fetchByfilter('Currencies');
    console.log("getAllCurrencyName===",apiResponse);
    return apiResponse;
  }
  export const submitProposal = async (postData)=>{

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data' // Set the Content-Type header
      }
    };
  
    const endpoint = Globals.ENDPOINT.SOLICITED_SUBMIT_PROPOSAL ;
    const apiResponse= await axios.post(endpoint,postData,config);
    console.log("submitProposal===",apiResponse);
    return apiResponse; 
  }